import { PolicyPageLayout } from "./PolicyPageLayout";

export const HSEPolicyPage = () => {
  return (
    <PolicyPageLayout
      eyebrow="Arihant Infracon"
      title="Health, Safety & Environment Policy"
      sections={[
        {
          title: "Policy Statement",
          body: [
            "Arihant Infracon is committed to providing a safe, healthy and injury-free work environment for all employees, contractors, visitors and stakeholders. We recognize that health and safety are fundamental responsibilities and integral to sustainable project execution.",
          ],
        },
        {
          title: "HSE Objectives",
          bullets: [
            "Prevent accidents, injuries and occupational illnesses.",
            "Eliminate hazards and reduce HSE risks.",
            "Comply with all applicable HSE laws, regulations and airport safety norms.",
            "Promote a proactive safety culture across all levels.",
          ],
        },
        {
          title: "HSE Management System",
          body: [
            "Our HSE Management System is aligned with ISO 45001:2018 and includes:",
          ],
          bullets: [
            "Project-specific HSE Plans.",
            "Risk assessment and hazard identification.",
            "Permit-to-Work (PTW) systems.",
            "Emergency preparedness and response plans.",
          ],
        },
        {
          title: "Hazard Identification & Risk Assessment",
          body: [
            "We systematically identify and control hazards related to:",
          ],
          bullets: [
            "Working at height.",
            "Hot works.",
            "Lifting operations.",
            "Electrical works.",
            "Confined spaces.",
            "Airside operations under NOTAM conditions.",
          ],
        },
        {
          title: "Training & Awareness",
          body: ["We ensure:"],
          bullets: [
            "Mandatory safety induction for all personnel.",
            "Tool-box talks and refresher training.",
            "Specialized training for high-risk activities.",
            "Competency verification of operators and supervisors.",
          ],
        },
        {
          title: "Personal Protective Equipment (PPE)",
          body: [
            "Appropriate PPE is mandatory at all sites. Compliance is monitored continuously, and violations are addressed immediately.",
          ],
        },
        {
          title: "Incident Reporting & Investigation",
          body: [
            "All incidents, near-misses and unsafe conditions are:",
          ],
          bullets: [
            "Reported promptly.",
            "Investigated systematically.",
            "Analysed for root causes.",
            "Addressed through corrective actions.",
          ],
        },
        {
          title: "Management Commitment",
          body: [
            "Management demonstrates visible leadership in safety by allocating resources, enforcing accountability and fostering a culture where safety is never compromised for productivity.",
          ],
        },
      ]}
    />
  );
};
